import React from "react"

import { Input } from "@coval/ui"

import { useTestSetEditorContext } from "../contexts/TestSetEditorContext"
import { EVENTS, useEventDispatcher } from "../event-bus"
import { TestSetMetadata } from "./TestSetMetadata"

/**
 * Top row of the test set platter: the editable description alongside the
 * creation/edit attribution, so both sit on the card with the grid rather than
 * on the page canvas above it.
 */
export const TestSetDetailsRow: React.FC = () => {
  const dispatch = useEventDispatcher()
  const { testSetId, metadata } = useTestSetEditorContext()

  return (
    <div className="shrink-0 w-full border-b border-coval-border px-6 py-3">
      <div className="flex items-center gap-4">
        <div className="flex-1 min-w-0">
          <Input
            data-testid="test-set-editor-description-input"
            placeholder="Add a description..."
            value={metadata.description || ""}
            onChange={(e) =>
              dispatch(EVENTS.METADATA_UPDATE, { description: e.target.value })
            }
            aria-label="Test set description"
          />
        </div>

        <TestSetMetadata
          testSetId={testSetId}
          createdAt={metadata.createdAt}
          lastUpdatedAt={metadata.lastUpdatedAt}
          createdByUserId={metadata.createdByUserId}
        />
      </div>
    </div>
  )
}
